import {css} from '@emotion/core'
import styled from '@emotion/styled'
import {headerMaxWidth, marketingMobileCuttoff, ipadproMax, radiantBlue} from "@css/constants";
import { FontNormal } from '@css/fonts'
import { fontSize } from '@css/styles'
import { lochmaraBlue } from '@css/constants'

const sidebarWidth = '360px';

export const ArticleSectionContainer = styled('div')(css`
  margin: 0;
`)

export const ContentWrapper = styled('div')(css`
  margin: 0 auto;
  max-width: 1000px;
  width: 90%;

  @media(min-width: ${marketingMobileCuttoff}) and (max-width: ${ipadproMax}) {
    width: 96%;
  }
`);

export const ArticleSectionRow = styled('div')(css`
  display: flex;
  flex-direction: row;
  margin-top: 5px;

  @media(max-width: ${marketingMobileCuttoff}) {
    flex-direction: column;
  }
`);

export const SocialShareButtonsWrapper = styled('div')(css`
  width: 100%;
  text-align: end;
  display: flex;
  & > div {
    justify-content: flex-end;
    min-width: 250px;

    & > div {
      @media(max-width: ${marketingMobileCuttoff}) {
        margin-right: 12px;
      }

      & > a {
        padding-right: 20px;
      }

      & > button {
        padding-right: 20px;
      }
    }

    & > div > a:last-child {
      padding-right: 0px;
    }
  }

  @media(max-width: ${marketingMobileCuttoff}) {
    margin-top: 20px;
    text-align: start;
    justify-content: flex-start;
  }

`);

export const MainContent = styled('div')(css`
  float: left;
  width: calc(100% - ${sidebarWidth});
  padding: 20px 0 80px;

  @media(max-width: ${marketingMobileCuttoff}) {
    float: none;
    width: 100%;
    padding: 20px 0 40px;
  }
`);

export const Sidebar = styled('div')(css`
  float: left;
  width: ${sidebarWidth};

  @media(max-width: ${marketingMobileCuttoff}) {
    float: none;
    width: 100%;
    display: flex;
    place-content: center;
    margin-bottom: 40px;
  }
`);


export const SidebarContent = styled('div')(css`
  width: 300px;
  float: right;

  @media(max-width: ${marketingMobileCuttoff}) {
    width: 100%;
    float: none;
  }
`);

export const Sep = styled('div')(css`
  margin: 20px 0;
  height: 2px;
  width: 100%;
  background-color: #B1B7BA;
`);

export const SectionTitle = styled('h2')(css`
  ${FontNormal(600)};
  ${fontSize(20)};
  margin-top: 30px;
  margin-bottom: 10px;
`)

export const RelatedLink = styled('div')(css`
  margin-top: 20px;
`)

export const SectionText = styled('p')(css`
  ${fontSize(16)};
  ${FontNormal(400)};
  width: 100%;
  align-self: center;
  
  & > a {
    ${FontNormal(600)};
    color: ${radiantBlue};
  }

  ol {
    margin: 0 0 1.5em;
    padding-left: 20px;
    counter-reset: item;

    li {
      ${fontSize(16)};
      ${FontNormal(400)};
      margin-bottom: 15px;
      padding: 0 0 0 16px;
      text-indent: -2em;
      list-style-type: none;
      counter-increment: item;

      :before {
        ${fontSize(16)};
        ${FontNormal(600)};
        display: inline-block;
        width: 1em;
        padding-right: 16px;
        text-align: right;
        content: counter(item) ".";
      }
    }
  }
`)

export const SectionLink = styled('a')(css`
  ${FontNormal(400)};
  text-decoration: underline;
  color: ${lochmaraBlue};
`);

export const ShareText = styled(SectionText)(css`
  @media(min-width: ${marketingMobileCuttoff}) and (max-width: ${headerMaxWidth}) {
    display: none;
  }

  @media(max-width: ${marketingMobileCuttoff}) {
    width: min-content;
  }
`);
